module.exports = __webpack_public_path__ + "static/img/p5_11.943f02b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/aboutOur/intro/p5_11.jpg
// module id = so8k
// module chunks = 0